import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  RouteDetail,
  Route,
  SuggestedRoute,
  RouteStatus,
  type SuggestedStop,
} from "../../hooks/react-query/dispatch/useRoutes";
import { getBusinessDayStart } from "../mockUtils";
import { tagNameToShipmentTagMap } from "../../types/shipmentTag.type";
import { ONTServiceCenter } from "../../types/serviceCenter.type";
import { mockDispatchStops } from "./stops.mock";

dayjs.extend(utc);
dayjs.extend(timezone);
const ontTz = ONTServiceCenter.timeZone;

export const mockDispatchRouteDetail = {
  default: [
    {
      id: 1,
      name: "PDZ-1",
      driver: {
        id: 123,
        name: "John Doe",
        profilePicture:
          "https://ui-avatars.com/api/?name=John+Doe&size=128&background=026AB7&color=fff",
        isEmployee: true,
        shiftStartTime: getBusinessDayStart()
          .add(5, "minutes")
          .tz(ontTz, true)
          .utc(),
      },
      statusStartDate: getBusinessDayStart(),
      nextStop: {
        id: 101,
        name: "Stop 1",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      stops: mockDispatchStops.default.filter(
        (stop) => "routeId" in stop && stop.routeId === 1
      ),
      equipments: {
        trailer: { id: "TRAILER-1", length: 53 },
        tractor: { id: "TRACTOR-1" },
        straightTruck: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      endRouteEta: getBusinessDayStart().add(9, "hours").tz(ontTz, true).utc(),
      status: "DEPT",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      stopsCompleted: 1,
      mealBreaks: [
        {
          startTime: dayjs().add(25, "minutes"),
          statusName: "Pending",
          punchIn: null,
          punchOut: null,
          suggestAfterStopSeq: null,
        },
      ],
    },
    {
      id: 2,
      name: "FUL-1",
      driver: {
        id: 123,
        name: "Jane Smith",
        profilePicture:
          "https://ui-avatars.com/api/?name=Jane+Smith&size=128&background=026AB7&color=fff",
        isEmployee: true,
        shiftStartTime: getBusinessDayStart()
          .add(3, "minutes")
          .tz(ontTz, true)
          .utc(),
      },
      statusStartDate: getBusinessDayStart().tz(ontTz, true).utc(),
      nextStop: {
        id: 23451,
        name: "Stop 1",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      stops: mockDispatchStops.default.filter(
        (stop) => "routeId" in stop && stop.routeId === 2
      ),
      equipments: {
        trailer: undefined,
        tractor: undefined,
        straightTruck: { id: "STRAIGHT-TRUCK-1" },
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      endRouteEta: getBusinessDayStart().add(9, "hours").tz(ontTz, true).utc(),
      status: "DISP",
      statusMessage: "Returning to Service Center",
      startTime: getBusinessDayStart().add(-1, "hours").tz(ontTz, true).utc(),
      stopsCompleted: 0,
      mealBreaks: [],
    },
    {
      id: 3,
      name: "ANA-1",
      driver: {
        id: 183,
        name: "Alice Johnson",
        profilePicture: undefined,
        isEmployee: false,
        shiftStartTime: null,
      },
      statusStartDate: getBusinessDayStart().tz(ontTz, true).utc(),
      nextStop: {
        id: 3459,
        name: "Stop 1",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      stops: mockDispatchStops.default.filter(
        (stop) => "routeId" in stop && stop.routeId === 3
      ),
      equipments: {
        trailer: { id: "TRAILER-1", length: 53 },
        tractor: { id: "TRACTOR-1" },
        straightTruck: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      endRouteEta: getBusinessDayStart().add(9, "hours").tz(ontTz, true).utc(),
      status: "CLDK",
      statusMessage: "Returning to Service Center",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      stopsCompleted: 0,
      mealBreaks: [],
    },
    {
      id: 4,
      name: "FON-1",
      driver: {
        id: 123,
        name: "Bob Williams",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart()
          .add(7, "minutes")
          .tz(ontTz, true)
          .utc(),
      },
      statusStartDate: getBusinessDayStart().tz(ontTz, true).utc(),
      nextStop: {
        id: 101,
        name: "Stop 1",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      stops: mockDispatchStops.default.filter(
        (stop) => "routeId" in stop && stop.routeId === 1
      ),
      equipments: {
        trailer: { id: "TRAILER-1", length: 53 },
        tractor: { id: "TRACTOR-1" },
        straightTruck: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      endRouteEta: getBusinessDayStart().add(9, "hours").tz(ontTz, true).utc(),
      status: "CPLT",
      statusMessage: "Returning to Service Center",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      stopsCompleted: 0,
      mealBreaks: [],
    },
    {
      id: 5,
      name: "FUL-1",
      driver: {
        id: 105,
        name: "Jane Smith",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      statusStartDate: getBusinessDayStart().tz(ontTz, true).utc(),
      nextStop: {
        id: 105,
        name: "Stop 2",
        sequence: 1,
        closeTime: dayjs().add(3, "hours").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      stops: mockDispatchStops.default.filter(
        (stop) => "routeId" in stop && stop.routeId === 5
      ),
      equipments: {
        trailer: { id: "TRAILER-2", length: 48 },
        tractor: { id: "TRACTOR-2" },
        straightTruck: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(4, "hours")
        .tz(ontTz, true)
        .utc(),
      endRouteEta: getBusinessDayStart().add(4, "hours").tz(ontTz, true).utc(),
      status: "DISP",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      stopsCompleted: 1,
      mealBreaks: [],
    },
    {
      id: 6,
      name: "LBY-1",
      driver: {
        id: 456,
        name: "Mike O'Connor",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      statusStartDate: getBusinessDayStart().tz(ontTz, true).utc(),
      nextStop: {
        id: 106,
        name: "Stop 4",
        sequence: 1,
        closeTime: dayjs().add(3.5, "hours").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      stops: mockDispatchStops.default.filter(
        (stop) => "routeId" in stop && stop.routeId === 6
      ),
      equipments: {
        trailer: { id: "TRAILER-4", length: 48 },
        tractor: { id: "TRACTOR-4" },
        straightTruck: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(7, "hours")
        .tz(ontTz, true)
        .utc(),
      endRouteEta: getBusinessDayStart().add(7, "hours").tz(ontTz, true).utc(),
      status: "DEPT",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      stopsCompleted: 1,
      mealBreaks: [],
    },
    {
      id: 7,
      name: "ONT-2",
      driver: {
        id: 789,
        name: "Emily Clarke",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      statusStartDate: getBusinessDayStart().tz(ontTz, true).utc(),
      nextStop: {
        id: 107,
        name: "Stop 5",
        sequence: 1,
        closeTime: dayjs().add(4, "hours").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      stops: mockDispatchStops.default.filter(
        (stop) => "routeId" in stop && stop.routeId === 7
      ),
      equipments: {
        trailer: { id: "TRAILER-5", length: 53 },
        tractor: { id: "TRACTOR-5" },
        straightTruck: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      endRouteEta: getBusinessDayStart().add(9, "hours").tz(ontTz, true).utc(),
      status: "DEPT",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),

      stopsCompleted: 1,
      mealBreaks: [],
    },
    {
      id: 99,
      name: "ONT-3",
      driver: {
        id: 999,
        name: "Testward Testington",
        profilePicture: undefined,
        isEmployee: false,
        shiftStartTime: null,
      },
      statusStartDate: getBusinessDayStart().tz(ontTz, true).utc(),
      nextStop: {
        id: 999,
        name: "Stop 999",
        sequence: 1,
        closeTime: dayjs().add(4, "hours").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      stops: mockDispatchStops.default.filter(
        (stop) => "routeId" in stop && stop.routeId === 99
      ),
      equipments: {
        trailer: { id: "TRAILER-5", length: 53 },
        tractor: { id: "TRACTOR-5" },
        straightTruck: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      endRouteEta: getBusinessDayStart().add(9, "hours").tz(ontTz, true).utc(),
      status: "DISP",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),

      stopsCompleted: 1,
      mealBreaks: [],
    },
  ],
} as const satisfies Record<string, RouteDetail[]>;

export const mockDispatchRoutes = {
  empty: [],
  default: [
    {
      id: 1,
      name: "PDZ-1",
      driver: {
        id: 123,
        name: "John Doe",
        profilePicture:
          "https://ui-avatars.com/api/?name=John+Doe&size=128&background=026AB7&color=fff",
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      nextStop: {
        id: 101,
        name: "Stop 1",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      status: "DEPT",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      live: {
        deliveries: 2,
        pickups: 5,
        pallets: 3,
        pieces: 50,
        weight: 200,
      },
      totalStops: 3,
      shipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR", "CC", "OSAD"]),
      liveShipmentTags: tagNameToShipmentTagMap(["CC", "OSAD"]),
      projectedShipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR"]),
      projectedTotalShipments: 1,
      projectedTotalPallets: 4,
      projectedTotalPieces: 25,
      projectedTotalHandlingUnits: 10,
      projectedTotalWeight: 100,
    },
    {
      id: 2,
      name: "FUL-1",
      driver: {
        id: 123,
        name: "Jane Smith",
        profilePicture:
          "https://ui-avatars.com/api/?name=Jane+Smith&size=128&background=026AB7&color=fff",
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      nextStop: {
        id: 231,
        name: "Stop 2",
        sequence: 2,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      status: "DISP",
      statusMessage: "Returning to Service Center",
      startTime: getBusinessDayStart().add(-1, "hours").tz(ontTz, true).utc(),
      live: {
        deliveries: 2,
        pickups: 5,
        pallets: 3,
        pieces: 50,
        weight: 200,
      },
      totalStops: 3,
      shipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR", "CC", "OSAD"]),
      liveShipmentTags: tagNameToShipmentTagMap(["CC", "OSAD"]),
      projectedShipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR"]),
      projectedTotalShipments: 1,
      projectedTotalPallets: 4,
      projectedTotalPieces: 25,
      projectedTotalHandlingUnits: 10,
      projectedTotalWeight: 100,
    },
    {
      id: 3,
      name: "ANA-1",
      driver: {
        id: 183,
        name: "Alice Johnson",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      nextStop: {
        id: 2345,
        name: "Stop 9",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      status: "CLDK",
      statusMessage: "Returning to Service Center",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      live: {
        deliveries: 2,
        pickups: 5,
        pallets: 3,
        pieces: 50,
        weight: 200,
      },
      totalStops: 3,
      shipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR", "CC", "OSAD"]),
      liveShipmentTags: tagNameToShipmentTagMap(["CC", "OSAD"]),
      projectedShipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR"]),
      projectedTotalShipments: 1,
      projectedTotalPallets: 4,
      projectedTotalPieces: 25,
      projectedTotalHandlingUnits: 10,
      projectedTotalWeight: 100,
    },
    {
      id: 4,
      name: "FON-1",
      driver: {
        id: 123,
        name: "Bob Williams",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      nextStop: {
        id: 101,
        name: "Stop 1",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      status: "CPLT",
      statusMessage: "Returning to Service Center",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      live: {
        deliveries: 0,
        pickups: 0,
        pallets: 3,
        pieces: 50,
        weight: 200,
      },
      totalStops: 3,
      shipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR", "CC", "OSAD"]),
      liveShipmentTags: tagNameToShipmentTagMap(["CC", "OSAD"]),
      projectedShipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR"]),
      projectedTotalShipments: 1,
      projectedTotalPallets: 4,
      projectedTotalPieces: 25,
      projectedTotalHandlingUnits: 10,
      projectedTotalWeight: 100,
    },
    {
      id: 5,
      name: "FUL-1",
      driver: {
        id: 123,
        name: "Eva Davis",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      nextStop: {
        id: 435,
        name: "Stop G",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      status: "DISP",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      live: {
        deliveries: 2,
        pickups: 5,
        pallets: 3,
        pieces: 50,
        weight: 200,
      },
      totalStops: 3,
      shipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR", "CC", "OSAD"]),
      liveShipmentTags: tagNameToShipmentTagMap(["CC", "OSAD"]),
      projectedShipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR"]),
      projectedTotalShipments: 1,
      projectedTotalPallets: 4,
      projectedTotalPieces: 25,
      projectedTotalHandlingUnits: 10,
      projectedTotalWeight: 100,
    },
    {
      id: 6,
      name: "LBY-1",
      driver: {
        id: 123,
        name: "Mike O'Connor",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      nextStop: {
        id: 325,
        name: "Dest F",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      status: "DEPT",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      live: {
        deliveries: 2,
        pickups: 5,
        pallets: 3,
        pieces: 50,
        weight: 200,
      },
      totalStops: 3,
      shipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR", "CC", "OSAD"]),
      liveShipmentTags: tagNameToShipmentTagMap(["CC", "OSAD"]),
      projectedShipmentTags: tagNameToShipmentTagMap(["PFCL", "APTR"]),
      projectedTotalShipments: 1,
      projectedTotalPallets: 4,
      projectedTotalPieces: 25,
      projectedTotalHandlingUnits: 10,
      projectedTotalWeight: 100,
    },
    {
      id: 7,
      name: "ONT-2",
      driver: {
        id: 123,
        name: "Emily Clarke",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      nextStop: {
        id: 987,
        name: "Dest Y",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      status: "DEPT",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      live: {
        deliveries: 2,
        pickups: 5,
        pallets: 3,
        pieces: 50,
        weight: 200,
      },
      totalStops: 3,
      shipmentTags: tagNameToShipmentTagMap(["APTM", "CC", "UC"]),
      liveShipmentTags: tagNameToShipmentTagMap(["APTM", "CC"]),
      projectedShipmentTags: tagNameToShipmentTagMap(["UC"]),
      projectedTotalShipments: 1,
      projectedTotalPallets: 4,
      projectedTotalPieces: 25,
      projectedTotalHandlingUnits: 10,
      projectedTotalWeight: 100,
    },
    {
      id: 99,
      name: "ONT-3",
      driver: {
        id: 999,
        name: "Testward Testington",
        profilePicture: undefined,
        isEmployee: true,
        shiftStartTime: getBusinessDayStart(),
      },
      nextStop: {
        id: 999,
        name: "Dest 999",
        sequence: 1,
        closeTime: dayjs().add(1, "hour").tz(ontTz, true).utc(),
        arrivedAt: undefined,
      },
      estimatedRouteEndTime: getBusinessDayStart()
        .add(9, "hours")
        .tz(ontTz, true)
        .utc(),
      status: "DISP",
      statusMessage: "Driving to next stop",
      startTime: getBusinessDayStart().tz(ontTz, true).utc(),
      live: {
        deliveries: 2,
        pickups: 5,
        pallets: 3,
        pieces: 50,
        weight: 200,
      },
      totalStops: 3,
      shipmentTags: tagNameToShipmentTagMap(["APTM", "CC", "UC"]),
      liveShipmentTags: tagNameToShipmentTagMap(["APTM", "CC"]),
      projectedShipmentTags: tagNameToShipmentTagMap(["UC"]),
      projectedTotalShipments: 1,
      projectedTotalPallets: 4,
      projectedTotalPieces: 25,
      projectedTotalHandlingUnits: 10,
      projectedTotalWeight: 100,
    },
  ],
} as const satisfies Record<string, Route[]>;

export const mockDispatchSuggestedRoutes = {
  empty: [],
  default: [
    {
      routeId: 1,
      milesAway: 3,
    },
    {
      routeId: 2,
      milesAway: 4,
    },
    {
      routeId: 5,
      milesAway: 5,
    },
  ],
} as const satisfies Record<string, SuggestedRoute[]>;

export const mockDispatchAvailableRouteStatuses = {
  empty: [],
  default: [],
  routeWithStatusDisp: ["DISP", "CRHM", "CARV"],
  routeWithStatusCldv: ["CLDV", "DISP"],
  routeWithStatusCldk: ["CLDK", "CLDV"],
} as const satisfies Record<string, RouteStatus[]>;

export const mockDispatchSuggestedStops = {
  empty: [],
  default: [{ stopId: 4 }, { stopId: 14 }],
} as const satisfies Record<string, SuggestedStop[]>;
